export const DEFAULT_SHOW_DELAY = 500;
export const DEFAULT_HIDE_DELAY = 200;
